import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const SignInPageAsync = lazy(() => import('./ui/SignInPage'));

export const SignInPage = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <SignInPageAsync />
    </Suspense>
  );
};
